export const ACTION_LOAD_FONTS = 'LOAD_FONTS';

import { namespace } from './namespace';
export const ACTION_FONT_LOAD_FONTS = `${namespace}${ACTION_LOAD_FONTS}`;
